import { Controller } from "@hotwired/stimulus"
import { showFlashMessage } from "../helpers/flash_helper"

export default class extends Controller {
  static targets = ['mediaEditModal', 'assetForm', 'editForm']
  static values = {
    useJsonResponse: { type: Boolean, default: false }
  }

  async loadEditModal(event) {
    event.preventDefault()
    this.assetUrl = event.params.assetUrl
    this.triggeringElement = event.currentTarget
    this.assetFormTarget.innerHTML = await this.loadAsset()

    $(this.mediaEditModalTarget).modal('show')
  }

  async loadAsset() {
    const url = new URL(this.assetUrl, window.location.origin)

    try {
      const response = await fetch(url, { method: 'GET' } )
      return response.text()
    } catch (error) {
      console.error(error)
    }
  }

  async handleFormSubmit(event) {
    if (!this.useJsonResponseValue) return

    event.preventDefault()

    const formData = new FormData(this.editFormTarget)
    const url = this.editFormTarget.action
    await this.makeRequest(url, 'PATCH', formData)
  }

  async handleDuplicate(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const url = event.currentTarget.href
    const formData = new FormData(this.editFormTarget)

    // Remove _method field to ensure POST request (form has _method=patch for updates)
    formData.delete('_method')

    await this.makeRequest(url, 'POST', formData)
  }

  async handleRestoreOriginal(event) {
    if (!this.useJsonResponseValue) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const confirmMessage = event.currentTarget.dataset.confirmMessage
    if (confirmMessage && !confirm(confirmMessage)) {
      return
    }

    const url = event.currentTarget.href
    await this.makeRequest(url, 'POST')
  }

  async makeRequest(url, method = 'POST', body = null) {
    try {
      const response = await this.fetchRequest(url, method, body, this.useJsonResponseValue)

      if (this.useJsonResponseValue) {
        const data = await response.json()
        this.handleJsonResponse(data, response.ok)
      } else if (response.ok) {
        window.location.reload()
      } else {
        console.error('Request failed:', response.statusText)
      }
    } catch (error) {
      console.error(`Error with ${method} request:`, error)
      if (this.useJsonResponseValue) {
        showFlashMessage(`An error occurred: ${error.message}`, 'danger')
      }
    }
  }

  async fetchRequest(url, method, body, acceptJson = false) {
    const headers = {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    }

    if (acceptJson) {
      headers['Accept'] = 'application/json'
    }

    const options = { method, headers }

    if (body) {
      options.body = body
    }

    return await fetch(url, options)
  }

  handleJsonResponse(data, success) {
    if (success) {
      $(this.mediaEditModalTarget).modal('hide')
      this.updateTriggeringElementImage(data.asset_url)
      showFlashMessage(data.message, 'success')

    } else {
      const errorMessage = data.errors ? data.errors.join(', ') : 'An error occurred'
      showFlashMessage(errorMessage, 'danger')
    }
  }

  updateTriggeringElementImage(assetUrl) {
    const mediaContainer = this.triggeringElement.closest('[data-media-library-target="mediaContainer"]')
    const img = mediaContainer.querySelector('img')

    // Add cache-busting parameter to force browser to reload the image
    img.src = assetUrl + (assetUrl.includes('?') ? '&' : '?') + 't=' + new Date().getTime()
  }
}
